import SearchIcon from '@mui/icons-material/Search';
import {
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Toolbar,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { listCategoriesAll } from '../../api/products';
import useAuthToken from '../../hooks/getUserData';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
  marginLeft: 'auto',
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 320,

  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

export default function ProductListToolbar({
  filterName,
  onFilterName,
  selectedCategory,
  onCategoryChange,
}) {
  const [categories, setCategories] = useState([]);
  const token = useAuthToken();

  const fetchCategories = async () => {
    try {
      if (token) {
        const response = await listCategoriesAll(token);

        const data = await response.json();
        setCategories(data?.categories);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCategories();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Toolbar>
      <Select
        value={selectedCategory}
        onChange={onCategoryChange}
        inputProps={{
          name: 'category',
          id: 'category-select',
        }}
        sx={{ marginLeft: '16px' }}>
        <MenuItem key="all_products" value="All Products">
          All Categories
        </MenuItem>
        {categories && categories.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
      <StyledRoot>
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon fontSize="medium" />
            </InputAdornment>
          }
        />
      </StyledRoot>
    </Toolbar>
  );
}
